'use client';

import React from 'react';
import { Button } from '@/components/ui/button';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body className="bg-background text-foreground min-h-screen flex items-center justify-center p-4">
        <div className="max-w-md w-full text-center space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl font-bold font-headline tracking-tighter text-primary">System Interruption</h1>
            <p className="text-muted-foreground">
              A temporary technical issue occurred while generating this report. Our newsroom has been notified.
            </p>
            {error.digest && (
              <p className="text-[10px] font-mono opacity-40 uppercase tracking-widest">
                Digest: {error.digest}
              </p>
            )}
          </div>
          <div className="flex flex-col gap-3">
            <Button 
              onClick={() => reset()}
              className="bg-primary hover:bg-primary/90 font-bold h-12 w-full"
            >
              Attempt Recovery
            </Button>
            <Button 
              variant="outline" 
              asChild
              className="h-12 w-full font-bold border-primary/20"
            >
              <a href="/">Return to Newsroom</a>
            </Button>
          </div>
        </div>
      </body>
    </html>
  );
}
